
angular.module('tf.directives')

    .directive('chartUnitPicker', function() {
    return {
        restrict: 'E',
        templateUrl: "js/components/charts/chartUnitPicker/chartUnitPicker.html",
        replace: true,
        scope : {
            unit : '='
        },
        link : function(scope, element){

        }

    };
});